<template>
  <div id="container">
    <div class="  flex w-full   p-5">
      <div class="vx-col flex items-center justify-center flex-col  mx-auto ">
        <vs-button @click="$emit('close')" size="large">Back</vs-button>
        <h1>{{ showTitle }}</h1>

        <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
        <div v-if="scannedResult">{{ scannedResult }}</div>

        <vs-divider>result</vs-divider>
        {{ scannedResult }}
      </div>
    </div>
  </div>
</template>
<script>
import VueQrcodeReader from 'vue-qrcode-reader';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import { StreamBarcodeReader } from "vue-barcode-reader";
import { alertMixin } from '../../mixin/alertMixin';
export default {
  mixins: [axiosMixin, alertMixin],
  components: {
    StatisticsCardLine,
    StreamBarcodeReader
  },
  data() {
    return {
      scannedResult: null,
    };
  },
  props: {
    subject: {
      type: String,
      default: false,
    },
    id: {
      type: Number,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
  },
  computed: {
    showTitle() {
      return this.subject == 'gr' ? 'Goods Received' : 'Goods Sent Out';
    },
    subjectUpper() {
      return this.subject.toUpperCase();
    }
  },
  methods: {
    onDecode(text) {
      if (this.code == text) {
        this.$emit('showForm');
      } else {
        this.errorAlert('Error', 'QR Code not match');
      }
    },
    onLoaded() {
      // alert(`Ready to start scanning barcodes`)
    },
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    getData() {
      this.startLoading();
      this.aronPost('getData', {}, '', '')
        .then(response => {
          if (response.status) {
          } else {
            this.errorAlert('Error', response.data.error)
          }

          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })

    }

  },
  mounted() {

  },
  created() {

  }
};
</script>
